// import { useState } from "react";
import { useEffect, useState, useContext, useRef } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

//  React components
import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";

//  React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import FormField from "./components/FormField";
import { Autocomplete } from "@mui/material";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { NavLink, useNavigate, useParams } from "react-router-dom";

import { v4 as uuidv4 } from "uuid";

const axios = require("axios").default;
import { DataContext } from "context/dataContext";
import ErrorText from "components/ErrorText";

const EditQuote = () => {
  const params = useParams();

  const { dataState, getSingleQuoteApi, updateQuoteApi } = useContext(DataContext);
  const navigate = useNavigate();

  const [value, setValue] = useState({
    quote: "",
    author: "",
  });

  const [errors, setErrors] = useState({
    quote: "",
    author: "",
  });

  const uuidvNumbers = () => {
    const uuid = uuidv4();
    const uuidFinal = uuid.replace(/\D/g, "").slice(0, 12);
    return Number(uuidFinal);
  };

  const validateForm = () => {
    const newErrors = {
      quote: value.quote ? "" : "Quote is required",
      author: value.author ? "" : "Author is required",
    };

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const handleQuote = (e) => {
    setValue({ ...value, quote: e.target.value });
  };

  const handleAuthor = (e) => {
    setValue({ ...value, author: e.target.value });
  };

  const ResetValue = () => {
    setValue({ ...value, quote: "" });
    setValue({ ...value, author: "" });
  };

  const handleSubmit = (e) => {
    console.log("value", value);
    e.preventDefault();

    if (validateForm()) {
      var quote_id = params.id;

      updateQuoteApi({
        id: quote_id,
        quote: value.quote,
        author: value.author,
        created_on: new Date(),
      }).then((res) => {
        if (res.success) {
          console.log("Quote updated");
          //window.location.refresh(false);
          navigate("/library/quote-list");
          ResetValue();
        } else {
          console.log("Something went wrong");
        }
      });
    }
  };

  // get old data from url
  useEffect(() => {
    let quote_id = params.id;

    getSingleQuoteApi(quote_id).then((res) => {
      if (res.success) {
        let resData = res?.data?.data?.quote;
        console.log(resData);

        setValue({
          quote: resData?.quote || "",
          author: resData?.author || "",
        });
      } else {
        console.log("Something went wrong");
      }
    });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={2} mb={2}>
        <Grid container justifyContent="center" alignItems="center" gap={2} sx={{ height: "100%" }}>
          <Grid item xs={12} lg={12}>
            <MDBox display="flex" alignItems="center" gap={2}>
              <MDButton
                variant="gradient"
                color="primary"
                component={NavLink}
                to="/library/quote-list"
              >
                {" "}
                Go Back{" "}
              </MDButton>
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Card autoComplete="off" sx={{ height: "100%" }}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                gap={1}
                sx={{ height: "100%" }}
              >
                <Grid item xs={12} sm={12} p={3} pb={0}>
                  <MDTypography variant="h5">Edit - Quote</MDTypography>
                </Grid>
                <Grid item xs={12} sm={12} pb={2} p={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                      <FormField
                        type="text"
                        multiline
                        rows={2}
                        value={value.quote}
                        onChange={handleQuote}
                        label="Quote"
                      />
                      {errors.quote && <ErrorText errorName={errors.quote} />}
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <FormField
                        type="text"
                        label="Author"
                        value={value.author}
                        onChange={handleAuthor}
                      />
                      {errors.author && <ErrorText errorName={errors.author} />}
                    </Grid>

                    <Grid item xs={12}>
                      <MDButton variant="gradient" color="primary" onClick={handleSubmit}>
                        Save Quote
                      </MDButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
};

export default EditQuote;
